/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
import './learn-more.scss';

const { arrayOf, node, oneOfType, string } = proptypes;

export const LearnMore = ({ icon, title, children = null, link }) => {

  return (
    <div className="learn-more">
      <div className="learn-more__icon">
        {icon}
      </div>
      <div className="u__bold">{title}</div>
      {children}
      <a href={link} className="u__default-link">Learn More</a>
    </div>
  );
};

LearnMore.displayName = 'LearnMore';

LearnMore.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  icon: node.isRequired,
  link: string.isRequired,
  title: string.isRequired
};


